import { NavLink } from 'react-router-dom'
import { useApprovalsPendingCount } from '@/hooks/use-approvals'
import { useAuth } from '@/hooks/use-auth'
import { cn } from '@/lib/utils'
import { bottomNavByRole, type NavRole } from './nav-config'

const APPROVALS_PATHS = new Set(['/committee/approvals', '/admin/approvals'])

export function BottomNav({ role }: { role: NavRole }) {
  const { user } = useAuth()
  const featureAccess = user?.featureAccess
  const items = bottomNavByRole[role].filter(
    (item) => !item.feature || featureAccess?.[item.feature] !== false,
  )
  const isApprover = role === 'committee' || role === 'admin'
  const pendingCount = useApprovalsPendingCount(isApprover)

  if (items.length === 0) return null

  return (
    <nav className="fixed inset-x-0 bottom-0 z-50 h-16 border-t border-border bg-card lg:hidden">
      <div className="flex h-full">
        {items.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              cn(
                'relative flex flex-1 flex-col items-center justify-center gap-1 font-sans text-[10px] font-medium tracking-wide transition-colors duration-150',
                isActive ? 'text-green' : 'text-muted-foreground',
              )
            }
          >
            <span className="relative">
              <Icon size={22} strokeWidth={1.75} aria-hidden />
              {APPROVALS_PATHS.has(to) && pendingCount > 0 && (
                <span className="absolute -right-2 -top-1.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-destructive px-1 font-sans text-[9px] font-semibold text-white">
                  {pendingCount}
                </span>
              )}
            </span>
            {label}
          </NavLink>
        ))}
      </div>
    </nav>
  )
}
